import { render, staticRenderFns } from "./AdminScreen.vue?vue&type=template&id=caa63534&scoped=true"
import script from "./AdminScreen.vue?vue&type=script&lang=js"
export * from "./AdminScreen.vue?vue&type=script&lang=js"
import style0 from "./AdminScreen.vue?vue&type=style&index=0&id=caa63534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa63534",
  null
  
)

export default component.exports